// Create and open the modal

function floowOpenModal(content) {
  const modal = document.querySelector(".floow-modal");

  if (!modal) {
    // If theres no modal container, create one and put it at the beginning of the body
    const modalText = `
      <div class="floow-modal">
        <div class="floow-modal-background" onclick="floowCloseModal();"></div>
        <div class="floow-modal-content-container">
          <svg 
            class="floow-modal-close"
            onclick="floowCloseModal()"
            role="presentation" stroke-width="2" focusable="false" width="24" height="24" viewBox="0 0 24 24">
              <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343"></path>
          </svg>
          <div class="floow-modal-content"></div>
        </div>
      </div>  
      `;
    const modalHTML = new DOMParser().parseFromString(modalText, "text/html");
    const modalElement = modalHTML.body.querySelector(".floow-modal");
    document.body.prepend(modalElement);
  }

  // Put the content in the modal
  const modalContent = document.querySelector(".floow-modal-content");
  modalContent.innerHTML = content.innerHTML;

  // Open the modal
  document.querySelector(".floow-modal").setAttribute("open", "");
}

// Close the modal

function floowCloseModal() {
  document.querySelector(".floow-modal").removeAttribute("open");
}

// Money formatting

function floowFormatMoney(cents) {
  if (!cents) return "";
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  }).format(cents / 100);
}

// Initialize slider

function floowInitializeSlider(settings, id) {
  const sliderId = id;
  const slider = document.querySelector(`.slider-${sliderId}`);
  const leftArrow = document.querySelector(`.left-arrow-${sliderId}`);
  const rightArrow = document.querySelector(`.right-arrow-${sliderId}`);

  // Schutz: wenn Slider/Arrows (noch) nicht im DOM sind, sauber abbrechen statt crashen
  if (!slider || !leftArrow || !rightArrow) return;

  const slides = Array.from(slider.children);
  if (slides.length === 0) return;
  let activeSlide = 0;

  slides.forEach((slide, i) => {
    slide.setAttribute("data-index", `${i}-${id}`);
  });

  floowCalculateSlideWidth(slider, slides, settings, activeSlide, id);

  const resizeObserver = new ResizeObserver((entries) => {
    for (let entry of entries) {
      floowCalculateSlideWidth(slider, slides, settings, activeSlide, id);
    }
  });

  resizeObserver.observe(slider);

  // Left arrow
  leftArrow.addEventListener("click", () => {
    if (activeSlide > 0) {
      activeSlide -= 1;
      rightArrow.classList.remove("floow-arrow-inactive");

      if (activeSlide == 0) leftArrow.classList.add("floow-arrow-inactive");

      const t = document.querySelector(`.block-${id}[data-index="${activeSlide}-${id}"]`);
      if (t) t.scrollIntoView({ inline: "start", behavior: "smooth", block: "nearest" });
    }
  });

  // Right arrow
  rightArrow.addEventListener("click", () => {
    if (window.innerWidth > settings.mobile.width) {
      if (activeSlide < slides.length - settings.slidesPerView)
        activeSlide += 1;
      if (activeSlide == slides.length - settings.slidesPerView)
        rightArrow.classList.add("floow-arrow-inactive");
    } else {
      if (activeSlide < slides.length - settings.mobile.slidesPerView)
        activeSlide += 1;
      if (activeSlide == slides.length - settings.mobile.slidesPerView)
        rightArrow.classList.add("floow-arrow-inactive");
    }

    leftArrow.classList.remove("floow-arrow-inactive");
    const t = document.querySelector(`.block-${id}[data-index="${activeSlide}-${id}"]`);
    if (t) t.scrollIntoView({ inline: "start", behavior: "smooth", block: "nearest" });
  });
}

// Calculate Slide Width
function floowCalculateSlideWidth(slider, slides, settings, activeSlide, id) {
  if (!slider || !slides || slides.length === 0) return;

  let sliderWidth = slider.getBoundingClientRect().width;
  let slideWidth;

  if (window.innerWidth > settings.mobile.width) {
    slideWidth =
      (sliderWidth - settings.gap * (settings.slidesPerView - 1)) /
      settings.slidesPerView;
  } else {
    slideWidth =
      (sliderWidth -
        settings.mobile.gap * (settings.mobile.slidesPerView - 1)) /
      settings.mobile.slidesPerView;
  }

  slides.forEach((slide) => {
    slide.style.width = `${slideWidth}px`;
  });

  const target = document.querySelector(
    `.block-${id}[data-index="${activeSlide}-${id}"]`
  );

  // Schutz: target kann bei fruehem/racy Aufruf null sein -> dann nicht scrollen
  if (!target) return;

  // Horizontales Scrollen
  slider.scrollTo({
    left: target.offsetLeft,
    behavior: "smooth"
  });
}


// Variant select
async function floowChangeVariant(productHandle, productId, sectionId, event) {
  const container = event.target.closest(
    `.floow-variant-picker-wrapper[product-id="${productId}"]`
  );
  const variantIds = [];

  container
    .querySelectorAll(
      `.floow-variant-picker-wrapper[product-id="${productId}"] .floow-variant-picker-value:checked`
    )
    .forEach((value) => {
      variantIds.push(value.getAttribute("value-id"));
    });

  const url = `${
    window.location.origin
  }/products/${productHandle}?section_id=${sectionId}&option_values=${variantIds.join(
    ","
  )}`;
  const response = await fetch(url);
  const htmlString = await response.text();
  const html = new DOMParser().parseFromString(htmlString, "text/html");

  // Replace Code
  container.innerHTML = html.querySelector(
    `.floow-variant-picker-wrapper[product-id="${productId}"]`
  ).innerHTML;
}